
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  emits: ['handleClick'],
  props: {
    format: {
      type: String as PropType<string>,
      default: 'button',
      validator: (value: string) => {
        return ['button', 'link', 'external'].includes(value)
      }
    },
    type: {
      type: String as PropType<string>,
      default: 'button',
      validator: (value: string) => {
        return ['button', 'submit'].includes(value)
      }
    },
    href: {
      type: String as PropType<string>
    },
    border: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    width: {
      type: String as PropType<string>,
      default: 'auto',
      validator: (value: string) => {
        return ['block', 'auto', 'medium'].includes(value)
      }
    },
    instance: {
      type: String as PropType<string>,
      default: ''
    },
    title: {
      type: String as PropType<string>
    },
    target: {
      type: String as PropType<string>,
      default: '_self',
      validator: (value: string) => {
        return ['_self', '_blank', '_top'].includes(value)
      }
    },
    status: {
      type: String as PropType<string>,
      default: '',
      validator: (value: string) => {
        return ['', 'active', 'disabled'].includes(value)
      }
    },
    ariaLabel: String as PropType<string>,
    ariaCurrent: Boolean as PropType<boolean>
  },
  methods: {
    onClickButton () {
      this.$emit('handleClick')
    },
    isPrimary (): boolean {
      return this.instance.indexOf('primary') > -1
    },
    isSecondary (): boolean {
      return this.instance.indexOf('secondary') > -1
    },
    isInvert (): boolean {
      return this.instance.indexOf('invert') > -1
    },
    isBlock (): boolean {
      return this.width === 'block'
    },
    isMedium (): boolean {
      return this.width === 'medium'
    },
    isActive (): boolean {
      return this.status === 'active'
    },
    isDisabled (): boolean {
      return this.status === 'disabled'
    },
    setClases () {
      return {
        'button--primary': this.isPrimary(),
        'button--secondary': this.isSecondary(),
        'button--invert': this.isInvert(),
        'button--block': this.isBlock(),
        'button--medium': this.isMedium(),
        'button--disabled': this.isDisabled(),
        'button--active': this.isActive()
      }
    }
  }
})
